<script setup lang="ts">
const props = defineProps({
  tooltipKey: {
    type: String,
    required: true,
  },
  tooltipKeyParams: {
    type: Object,
    required: false,
    default: () => {},
  },
})
</script>

<template>
  <span>
    <VIcon
      icon="mdi-information-variant-circle"
      size="small"
      class="tooltip__info-icon"
    />
    <VTooltip
      activator="parent"
      location="top"
      max-width="300"
    >
      {{ $t(props.tooltipKey, props.tooltipKeyParams) }}
      <slot />
    </VTooltip>
  </span>
</template>
